import { useQuery } from '@tanstack/react-query';
import type { TrackerActivityQuery } from '@pms/shared';
import { trackingService } from '@/services/tracking.service';
import { retryUnlessSetupError, trackerKeys } from './trackerQuery';

export function useTrackerActivity(query: TrackerActivityQuery) {
  return useQuery({
    queryKey: [...trackerKeys.activity, query],
    queryFn: () => trackingService.activity(query),
    retry: retryUnlessSetupError,
  });
}
